import FullPageLoader from "./FullPageLoader";

export default FullPageLoader;